/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import GridItem from "@insite/mobius/GridItem";
import GridContainer from "@insite/mobius/GridContainer";
import Zone from "@insite/client-framework/Components/Zone";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

const mapStateToProps = (state: ApplicationState) => ({
	pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface PageTitleVariantStyles {
	title: InjectableCss;
	pageInfoWrapper?: InjectableCss;
	pageTitleWrapper?: InjectableCss;
	pageInfo?: InjectableCss;
}


export const pageTitleVariantStyles: PageTitleVariantStyles = {
	title: {
		css: css`
			font-size: 41px;
			margin: 10px 0 40px 0;
			line-height: 46px;
			font-weight: 300;
			padding: 15px 0 0 0;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
						font-size: 24px;
						line-height: 30px;
						margin: 0;
						`,
						css`
						font-size: 24px;
						line-height: 30px;
						margin: 0;
						`,
						null,
					],
					"max"
				)}
		`
	},
	pageInfoWrapper: {
		css: css`
			display: flex; 
			font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans- serif;
			color: #333;
			div[class^="GridOffset"]{
				${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
                           margin:0;
						   width: 100%;
                            `,
						css`
                         	margin:0;
							width: 100%;
                            `,
						null,
					],
					"max"
				)}
			}
		`
	},
	pageTitleWrapper: {
		css: css`
			border-right: 1px solid #54575a;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
                            border: 0;
							padding: 0 0 30px 0;
                            `,
						css`
                            border: 0;
							padding: 0 0 30px 0;
                            `,
						null,
					],
					"max"
				)}
		`
	},
	pageInfo: {
		css: css`
			padding: 30px 0 10px 30px;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
						padding: 0;
						`,
						css`
						padding: 0;
						`,
						null,
					],
					"max"
				)}
			p{
				font-size: 14px;
				line-height: 20px;
				line-height: 23px;
				margin-bottom: 5px;
			}
		`
	}

}

const styles = pageTitleVariantStyles;

const PageTitleVariant: React.FunctionComponent<Props> = ({ pageTitle, fields, id }: Props) => (
	<StyledWrapper {...styles.pageInfoWrapper}>
		<GridContainer>
			<GridItem width={[12, 12, 4, 4, 4]} {...styles.pageTitleWrapper} >
				<Typography variant="h2" as="h1" data-test-selector="PageTitle" {...styles.title}>
					{fields.overrideTitle || pageTitle}
				</Typography>
			</GridItem>
			<GridItem width={[12, 12, 8, 8, 8]}  {...styles.pageInfo} >
				<StyledWrapper >
					<Zone contentId={id} zoneName="Content00" />
				</StyledWrapper>
			</GridItem>
		</GridContainer>
	</StyledWrapper>

);

const widgetModule: WidgetModule = {
	component: connect(mapStateToProps)(PageTitleVariant),
	definition: {
		group: "Basic",
		icon: "heading",
	},
};

export default widgetModule;
